import { createSlice } from '@reduxjs/toolkit';
import { fetchProducts } from '../actions/product.action';

const initialState = {
  products: {
    data: [],
    isLoading: false,
    isNeedReloadData: true,
  },
};

export const productReducer = createSlice({
  name: 'Product',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchProducts.pending, state => {
        state.products.isLoading = true;
        state.products.isNeedReloadData = false;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        if (action.payload) {
          const { data } = action.payload;
          state.products = { ...state.products, data, isLoading: false };
        }
      });
  },
});

export default productReducer.reducer;
